import { useState } from 'react';
import { useQuery } from '@apollo/client';
import { Button, Loading, QuickEdit } from '../../../../components';
import { SectionOwnerForm as SectionOwnerForm } from '../forms/SectionOwnerForm';
import { Modal } from '../../../../components/Modal';
import { FIND_SECTION_OWNER_BY_STRATEGY } from '../../queries';
import { useUserContext } from '../../../../context/PermissionsContext';

interface SectionOwnerProps {
  strategy: any;
  type:
    | 'Facility'
    | 'ITResource'
    | 'OtherConsideration'
    | 'People'
    | 'ProductionEquipment'
    | 'SupplyChain'
    | 'SupplyChainOutbound';
  isCorporate?: boolean;
}

type FindSectionOwnerByStrategy = {
  sectionOwnerfirstName: string;
  sectionOwnerlastName: string;
  sectionRequired?: boolean;
  email: string;
  uuid: string;
};

interface DataReturned {
  findSectionOwnerByStrategy: FindSectionOwnerByStrategy;
}

const SectionOwner = ({ strategy, type, isCorporate }: SectionOwnerProps) => {
  const [modalEditOpen, setModalEditOpen] = useState(false);
  const { isAdmin, canEdit } = useUserContext();

  const { data, refetch, loading, error } = useQuery<DataReturned>(
    FIND_SECTION_OWNER_BY_STRATEGY,
    {
      variables: { uuid: strategy, strategyType: type },
    },
  );

  if (loading) return <Loading />;
  if (error)
    return (
      <span className="text-danger font-bold text-center text-sm">
        Error! {error.message}
      </span>
    );

  const handleCloseSectionOwner = () => {
    setModalEditOpen(false);
    refetch();
  };

  return (
    <>
      <div className="m-6 inline-flex flex-row flex-nowrap justify-end items-center">
        <div>
          <p className="m-4 pl-8 text-sm text-primary-200   font-normal tracking-wider">
            SECTION OWNER |{' '}
            {`${data?.findSectionOwnerByStrategy?.sectionOwnerfirstName} ${data?.findSectionOwnerByStrategy?.sectionOwnerlastName}, ${data?.findSectionOwnerByStrategy?.email}`}
          </p>
          <p className="m-4 text-sm text-primary-200   font-normal tracking-wider">
            SECTION APPLICABLE |{' '}
            {data?.findSectionOwnerByStrategy?.sectionRequired ? 'Yes' : 'No'}
          </p>
        </div>
        {(isAdmin || canEdit) && (
          <Button type="edit" onClick={() => setModalEditOpen(true)}>
            <QuickEdit />
          </Button>
        )}
      </div>
      <Modal
        title="SECTION OWNER"
        open={modalEditOpen}
        onClose={handleCloseSectionOwner}
      >
        <SectionOwnerForm
          defaultValues={data?.findSectionOwnerByStrategy!}
          handleCancel={handleCloseSectionOwner}
          sectionId={data?.findSectionOwnerByStrategy?.uuid!}
          isStrategy
          isCorporate={isCorporate}
        />
      </Modal>
    </>
  );
};

export default SectionOwner;
